import { useSearchParams } from "react-router-dom";
import GlobalAppHeader from "@/components/shared/GlobalAppHeader";
import GlobalAppFooter from "@/components/shared/GlobalAppFooter";
import { Mail, Facebook, ShieldCheck, Clock } from "lucide-react";

export default function DataDeletionPage() {
  const [params] = useSearchParams();
  const confirmation = params.get("id");
  return (
    <div className="min-h-screen pf-app max-w-full overflow-x-hidden" data-testid="data-deletion-page">
      <GlobalAppHeader />
      <section className="max-w-3xl mx-auto px-6 py-12 space-y-5">
        <h1 className="display text-4xl font-black">Data Deletion Instructions</h1>
        <p className="text-xs pf-muted">Last updated {new Date().getFullYear()}</p>

        {confirmation && (
          <div className="nb-card p-4 bg-[#86EFAC]" data-testid="data-deletion-confirmation">
            <div className="nb-label">YOUR DELETION REQUEST</div>
            <p className="text-sm mt-1">We received your request. Confirmation code:</p>
            <p className="mono text-lg font-bold break-all mt-1">{confirmation}</p>
            <p className="text-xs mt-2">Your data will be permanently deleted within 30 days. Keep this code for reference.</p>
          </div>
        )}

        <p className="text-sm leading-relaxed pf-text">
          You can request deletion of your personal data from Ponderr at any time. We offer two ways to do this:
        </p>

        <div className="nb-card p-5 space-y-2">
          <div className="flex items-center gap-2 font-bold"><Mail size={18} /> 1. Request by Email</div>
          <p className="text-sm pf-text">
            Send an email to <a href="mailto:support@ponderr.school" className="underline font-bold" data-testid="data-deletion-email">support@ponderr.school</a> from
            the email address associated with your account, with the subject line <b>“Data Deletion Request”</b>. Include your full name and account/school name so we can locate your records.
          </p>
        </div>

        <div className="nb-card p-5 space-y-2">
          <div className="flex items-center gap-2 font-bold"><Facebook size={18} /> 2. Remove via Facebook App Settings</div>
          <p className="text-sm pf-text">If you signed in using Facebook, you can also revoke access and trigger deletion directly:</p>
          <ol className="text-sm pf-text list-decimal ml-5 space-y-1">
            <li>Go to your Facebook account <b>Settings &amp; Privacy → Settings</b>.</li>
            <li>Open <b>Apps and Websites</b>.</li>
            <li>Find <b>Ponderr</b> in your list of active apps and click <b>Remove</b>.</li>
            <li>Facebook will notify us, and we will delete the associated data automatically.</li>
          </ol>
        </div>

        <div className="nb-card p-5 bg-[#FDE047] flex items-start gap-3">
          <ShieldCheck size={22} className="mt-0.5 shrink-0" />
          <div>
            <div className="font-bold flex items-center gap-2"><Clock size={16} /> 30-Day Guarantee</div>
            <p className="text-sm">All verified data deletion requests are fully processed and permanently completed within <b>30 days</b>. We will confirm once your data has been removed.</p>
          </div>
        </div>
      </section>
      <GlobalAppFooter />
    </div>
  );
}
